import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { ChangePasswordModel, ChangePasswordUserModel } from "../../../models/inModels/ChangePasswordModel";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { error } from 'selenium-webdriver';
import { Message } from 'primeng/components/common/api';
import { ActivatedRoute, Router } from '@angular/router';
import { ShowHideInput } from '../../../directives/show-hide.directive';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
	model: any;
	loading = false;
	messages: Message[];
	show = false;
	UserId;
	@ViewChildren(ShowHideInput) input: QueryList<ShowHideInput>;

	constructor(
		private authenticationService: AuthenticationService,
		private route: ActivatedRoute,
		private router: Router) { }

	ngOnInit() {

		this.UserId = this.route.snapshot.paramMap.get("UserId");
		if (this.UserId) {
			this.model = new ChangePasswordUserModel();
			this.model.UserId = this.UserId;
		} else {
			this.model = new ChangePasswordModel();
		}
	}

	changePassword(): void {
		
		this.loading = true;
		if (this.UserId) {
			this.authenticationService.changeUserPassword(this.model).then(
				result => {
					this.loading = false;
					this.messages = [];
					this.messages.push({ severity: 'success', summary: 'Success', detail: 'Password successfully changed.' });
				},
				error => {
					this.loading = false;
					this.messages = [];
					this.messages.push({ severity: 'error', summary: 'Error', detail: error });
				});
		} else {
			this.authenticationService.changePassword(this.model).then(
				result => {
					this.loading = false;
					this.messages = [];
					this.messages.push({ severity: 'success', summary: 'Success', detail: 'Password successfully changed.' });
				},
				error => {
					this.loading = false;
					this.messages = [];
					this.messages.push({ severity: 'error', summary: 'Error', detail: error });
				});
		}
	}

	showPassword(event: any): void {
		this.show = true;
		this.changeType();
	}

	hidePassword(event: any): void {
		this.show = false;
		this.changeType();
	}

	changeType(): void {
		if (this.show) {
			this.input.forEach(inpt => {
				inpt.changeType("text");
			});
		}
		else {
			this.input.forEach(inpt => {
				inpt.changeType("password");
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/manage/change-password/change-password.component.ts